import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import StudyplusPop from './StudyplusPop'

export default function ShowPop() {
  const [openForMenu, setOpenForMenu] = useState(false)
  const handleClick = () => setOpenForMenu(!openForMenu)

  return (
    <>
      <button id="show_popup" className="dropdown-item" href="#" onClick={handleClick}>
        連携コードを確認
      </button>
      <StudyplusPop openForMenu={openForMenu} setOpenForMenu={setOpenForMenu} />
    </>
  )
}

if (document.getElementById('show_popup')) {
  ReactDOM.render(
    <ShowPop />,
    document.getElementById('show_popup')
  )
}